import React, { Component } from "react";
import { push as pushAction } from "react-router-redux";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import FlatButton from "material-ui/FlatButton";
import DatePicker from "material-ui/DatePicker";
import SelectField from "material-ui/SelectField";
import MenuItem from "material-ui/MenuItem";
import Toggle from "material-ui/Toggle";

import { showNotification as showNotificationAction } from "admin-on-rest";
import { fetchJson } from "./util/fetch";

class GenerateButton extends Component {
  constructor(props) {
    super(props);

    this.state = {
      month: null,
      year: null,
      force: false,
    };
  }

  handleClick = () => {
    const { showNotification } = this.props;
    var month = this.state.month;
    var year = this.state.year + 2018;
    var force = this.state.force;

    if (this.state.month == null || this.state.year == null) {
      showNotification("Le mois ou l'année n'est pas selectionné", "warning");
      return;
    }

    var options = {};
    if (!options.headers) {
      options.headers = new Headers({ Accept: "application/json" });
    }
    const token = localStorage.getItem("token");
    options.headers.set("Authorization", `Bearer ${token}`);
    const requestHeaders =
      options.headers || new Headers({ Accept: "application/xml" });

    fetchJson(process.env.REACT_APP_API_URL + `/generateLevy`, {
      method: "POST",
      body: JSON.stringify({
        year: year,
        month: month,
        force: force,
        isRealQuery: true,
      }),
      options: options,
      headers: requestHeaders,
    })
      .then((data) => {
        var wndw = window.open("", "", "data:text/xml");
        if (wndw) {
          var text = wndw.document.createTextNode(data.body);
          wndw.document.body.appendChild(text);
        }
      })
      .catch((e) => {
        console.error(e);
        showNotification(e.message, "warning");
      });
  };

  handleMonthChange = (event, month) => {
    this.setState({ month: month });
  };

  handleYearChange = (event, year) => {
    this.setState({ year: year });
  };

  handleToggle = (event, toggle) => {
    this.setState({ force: toggle });
  };

  render() {
    return (
      <div>
        <SelectField onChange={this.handleMonthChange} value={this.state.month}>
          <MenuItem value={0} primaryText="Janvier" />
          <MenuItem value={1} primaryText="Février" />
          <MenuItem value={2} primaryText="Mars" />
          <MenuItem value={3} primaryText="Avril" />
          <MenuItem value={4} primaryText="Mai" />
          <MenuItem value={5} primaryText="Juin" />
          <MenuItem value={6} primaryText="Juillet" />
          <MenuItem value={7} primaryText="Aout" />
          <MenuItem value={8} primaryText="Septembre" />
          <MenuItem value={9} primaryText="Octobre" />
          <MenuItem value={10} primaryText="Novembre" />
          <MenuItem value={11} primaryText="Décembre" />
        </SelectField>
        <SelectField onChange={this.handleYearChange} value={this.state.year}>
          <MenuItem value={0} primaryText="2018" />
          <MenuItem value={1} primaryText="2019" />
          <MenuItem value={2} primaryText="2020" />
          <MenuItem value={3} primaryText="2021" />
          <MenuItem value={4} primaryText="2022" />
          <MenuItem value={5} primaryText="2023" />
          <MenuItem value={6} primaryText="2024" />
          <MenuItem value={7} primaryText="2025" />
          <MenuItem value={8} primaryText="2026" />
          <MenuItem value={9} primaryText="2027" />
          <MenuItem value={10} primaryText="2028" />
          <MenuItem value={11} primaryText="2029" />
          <MenuItem value={12} primaryText="2030" />
        </SelectField>
        <FlatButton label="Générer les paiments" onClick={this.handleClick} />
        <Toggle onToggle={this.handleToggle} />
      </div>
    );
  }
}

GenerateButton.propTypes = {
  push: PropTypes.func,
  record: PropTypes.object,
  showNotification: PropTypes.func,
};

export default connect(null, {
  showNotification: showNotificationAction,
  push: pushAction,
})(GenerateButton);



// WEBPACK FOOTER //
// src/LevyButton.js